import Api from 'App/api'
// contacts
export const getContracts = Api.get({
  controller: 'contracts',
  action: 'list',
})
